module.exports = __webpack_public_path__ + "img/11a677c.jpg";